import { render, staticRenderFns } from "./WorldViewsPage.vue?vue&type=template&id=d5fc2f38&scoped=true&"
import script from "./WorldViewsPage.vue?vue&type=script&lang=ts&"
export * from "./WorldViewsPage.vue?vue&type=script&lang=ts&"
import style0 from "./WorldViewsPage.vue?vue&type=style&index=0&id=d5fc2f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fc2f38",
  null
  
)

export default component.exports